<div class="mock-config-form">
  <div class="form-content">
    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      <tn-form-field [label]="'Method Name' | translate" [required]="true">
        <tn-input
          testId="method-name-input"
          formControlName="methodName"
          [placeholder]="'e.g., pool.create' | translate"
        ></tn-input>
      </tn-form-field>

      <tn-form-field
        [label]="'Message Pattern (Optional)' | translate"
        [hint]="'Regex pattern to match against message content' | translate"
      >
        <tn-input
          testId="message-pattern-input"
          formControlName="messagePattern"
        ></tn-input>
      </tn-form-field>

      <tn-form-field [label]="'Response Type' | translate" [required]="true">
        <tn-radio-group
          formControlName="responseType"
          [options]="responseTypeOptions"
        ></tn-radio-group>
      </tn-form-field>

      @if (isErrorMode) {
        <tn-checkbox
          testId="is-call-error-checkbox"
          formControlName="isCallError"
          [label]="'Configure as CallError' | translate"
        ></tn-checkbox>
      }

      @if (!isErrorMode) {
        <tn-form-field
          [label]="'Response Data' | translate"
          [hint]="'JSON format expected' | translate"
        >
          <ix-code-editor
            formControlName="responseResult"
            [language]="CodeEditorLanguage.Json"
          ></ix-code-editor>
        </tn-form-field>
      }

      @if (isErrorMode) {
        <tn-form-field
          [label]="'Error Code' | translate"
          [required]="true"
          [hint]="'Select a standard code or enter a custom value' | translate"
        >
          <tn-autocomplete
            testId="error-code-input"
            formControlName="errorCode"
            [options]="errorCodeOptions"
            [allowCustomValue]="true"
          ></tn-autocomplete>
        </tn-form-field>
        <tn-form-field
          [label]="'Error Message' | translate"
          [required]="true"
          [hint]="'Human-readable error message' | translate"
        >
          <tn-input
            testId="error-message-input"
            formControlName="errorMessage"
          ></tn-input>
        </tn-form-field>

        @if (isCallErrorMode) {
          <tn-form-field
            [label]="'Error Name (errname)' | translate"
            [hint]="'Standard error name (e.g., EINVAL, EACCES)' | translate"
          >
            <tn-select
              testId="call-error-errname-select"
              formControlName="callErrorErrname"
              [options]="errorNameOptions"
            ></tn-select>
          </tn-form-field>
          <tn-form-field
            [label]="'Error Code (error)' | translate"
            [hint]="'Integer error code (e.g., 22 for EINVAL, 13 for EACCES)' | translate"
          >
            <tn-input
              testId="call-error-code-input"
              formControlName="callErrorCode"
              [inputType]="InputType.Number"
            ></tn-input>
          </tn-form-field>
          <tn-form-field
            [label]="'Error Reason' | translate"
            [hint]="'Human-readable reason for the error' | translate"
          >
            <tn-input
              testId="call-error-reason-input"
              formControlName="callErrorReason"
            ></tn-input>
          </tn-form-field>
          <tn-form-field
            [label]="'Extra Data (Optional)' | translate"
            [hint]="'Additional error context (e.g., validation errors) in JSON format' | translate"
          >
            <ix-code-editor
              formControlName="callErrorExtra"
              [language]="CodeEditorLanguage.Json"
            ></ix-code-editor>
          </tn-form-field>
          <tn-form-field
            [label]="'Stack Trace (Optional)' | translate"
            [hint]="'Mock stack trace in JSON format (auto-generated by default)' | translate"
          >
            <ix-code-editor
              formControlName="callErrorTrace"
              [language]="CodeEditorLanguage.Json"
            ></ix-code-editor>
          </tn-form-field>
        } @else {
          <tn-form-field
            [label]="'Error Data (Optional)' | translate"
            [hint]="'Additional error details in JSON format' | translate"
          >
            <ix-code-editor
              formControlName="errorData"
              [language]="CodeEditorLanguage.Json"
            ></ix-code-editor>
          </tn-form-field>
        }
      }

      <tn-form-field
        [label]="'Response Delay (ms)' | translate"
        [hint]="'Delay in milliseconds before returning the response' | translate"
      >
        <tn-input
          testId="response-delay-input"
          formControlName="responseDelay"
          [inputType]="InputType.Number"
          [placeholder]="'0' | translate"
        ></tn-input>
      </tn-form-field>

      <div class="events-section">
        <label>{{ 'Events (Optional)' | translate }}</label>
        <ix-job-event-builder
          [events]="form.controls.events.value ?? []"
          (eventsChange)="onEventsChange($event)">
        </ix-job-event-builder>
      </div>
    </form>
  </div>

  <div class="form-actions">
    <tn-button
      testId="cancel-button"
      variant="outline"
      [label]="'Cancel' | translate"
      (onClick)="onCancel()"
    ></tn-button>
    <tn-button
      testId="submit-button"
      color="primary"
      [disabled]="form.invalid"
      [label]="isEditMode ? ('Update' | translate) : ('Create' | translate)"
      (onClick)="onSubmit()"
    ></tn-button>
  </div>
</div>
